export const TAB_TEAMS = "teams";
export const TAB_SHAREHOLDERS = "shareholders";
export const TAB_EXTERNAL_USERS = "externalUsers";
export const TAB_TEAMS_AND_SHAREHOLDES = "teamsAndShareholders";
export const TAB_MY_PERSONAL_CONTACTS = "myPersonalContacts";
